import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import classNames from 'classnames'
import { ElementType } from 'react'

export interface IMenuItem {
  id: number | string
  label?: any
  disabled?: boolean
  componentProps?: Record<string, any>
  onClick?: any
  renderContent?: Function
}

const DropdownMenu = ({
  items,
  label,
  renderLabel,
  anchor = 'bottom',
  className,
  buttonClassName,
  buttonAs
}: {
  items: IMenuItem[]
  label?: string
  className?: string
  buttonClassName?: string
  anchor?: any
  renderLabel?: Function
  buttonAs?: ElementType
}) => {
  return (
    <div>
      <Menu as="div" className="relative flex-shrink-0">
        <div>
          <MenuButton
            as={buttonAs}
            className={classNames([
              'flex focus:outline-none text-oxford-gray-400 active:text-white',
              buttonClassName
            ])}
          >
            {renderLabel?.(label) ?? (
              <span className="flex content-center items-center">{label}</span>
            )}
          </MenuButton>
        </div>

        <MenuItems
          anchor={anchor}
          transition
          className={classNames([
            'z-40 mt-2 origin-top transition rounded-md bg-white shadow-lg overflow-hidden focus:outline-none',
            className
          ])}
        >
          {items.map((item, index) => {
            if (!item) return null

            return (
              <MenuItem key={item.id}>
                {({ focus }) => (
                  <button
                    disabled={item.disabled}
                    className={classNames([
                      'block px-4 py-3 text-sm w-100 text-left truncate leading-none',
                      {
                        'text-oxford-gray-800': !item.disabled,
                        'text-oxford-gray-300': item.disabled,
                        'text-primary': focus,
                        'border-t border-t-oxford-gray-100': index !== 0,
                        'hover:bg-electric-violet-50 hover:text-primary':
                          !item.disabled
                      }
                    ])}
                    onClick={item.onClick}
                    {...item.componentProps}
                  >
                    {item.label}
                  </button>
                )}
              </MenuItem>
            )
          })}
        </MenuItems>
      </Menu>
    </div>
  )
}

export default DropdownMenu
